import { atom } from 'jotai'

import { dataDisplayTypeAtom } from './stateAtoms'

export const isPercentageAtom = atom<boolean>((get) => {
  const dataDisplayType = get(dataDisplayTypeAtom)

  return dataDisplayType === 'percentage'
})
